<template>
  <section id="why">
    <div class="container pt-6">
      <div class="row align-items-center justify-content-between o-hidden">
        <div class="col-md-6 order-sm-1 mb-5 mb-sm-0">
          <img src="../assets/img/why-1.svg" alt="Image">
        </div>
        <div class="col-md-6 pr-xl-5 order-sm-2">
          <h2>Finding internal information should be easier.</h2>
          <p>Searching in internal document databases is often frustrating. Why is it not as fast, accurate, and intuitive as the search-engines provided by big tech companies?</p>
          <p>We believe that everyone should be able to use modern search technologies to find information in their own documents.</p>
        </div>
      </div>
    </div>
    <div class="container pt-6">
      <div class="row align-items-center justify-content-between o-hidden">
        <div class="col-md-6 pr-xl-5 order-sm-1">
          <h2>A new way to search in your documents.</h2>
          <p>Our goal is to make the internal search experience faster and more natural thanks to the latest advances in natural language processing using deep learning techniques.</p>
          <p>The mission of cdQA is to allow anyone to ask a question in natural language and get an answer without having to read the internal documents relevant to the question.</p>
        </div>
        <div class="col-md-6 order-sm-2 mb-5 mb-sm-0">
          <img src="../assets/img/why-2.svg" alt="Image">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Why"
};
</script>

<style>
</style>